export const dateFormats = {
  API_DATE_FORMAT: 'YYYY-MM-DD',
  API_DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
  API_TIME_FORMAT: 'HH:mm:ss',
  TWELVE_HOUR_DATE_TIME_FORMAT: 'YYYY-MM-DDThh:mm:ss',
  TWELVE_HOUR_TIME_FORMAT: 'hh:mm:ss A',
  DAY_MONTH_DAY_AND_TIME_DISPLAY_FORMAT: 'ddd MMM Do, YYYY [at] h:mm A',
  MONTH_DAY_YEAR_AND_TIME_DISPLAY_FORMAT: 'MMM DD, YYYY [at] hh:mm a',
  DAT_MONTH_YEAR_DISPLAY_FORMAT: 'ddd MMM Do, YYYY',
  SHORT_TWELVE_HOUR_TIME_FORMAT: 'h:mm A',
  SHORT_TWELVE_HOUR_TIME_FORMAT_NO_MERIDIEM: 'h:mm',
  TIME_PICKER_FORMAT: 'HH:mm:00 A',
  TWENTY_FOUR_HOUR_TIME: 'HH:mm',
  SHORT_MONTH_DAY_YEAR_DISPLAY: 'MMM DD, YYYY',
};



// WEBPACK FOOTER //
// ./src/common/constants/dateFormats.js